import React, { useState, useEffect } from "react";
import axios from "axios";
import ForecastDay from "./ForecastDay";
import "./DailyForecast.css";

export default function DailyForecast(props) {
  let [loaded, setLoaded] = useState(false);
  let [outlook, setOutlook] = useState(null);

  useEffect(() => {
    setLoaded(false);
  }, [props.info.city]);

  function getResponse(response) {
    console.log(response.data);
    setOutlook(response.data.daily);
    setLoaded(true);
  }

  if (loaded) {
    return (
      <div className="DailyForecast">
        <div className="row">
          {outlook.map(function (dailyForecast, index) {
            if (index < 5) {
              return (
                <div className="col" key={index}>
                  <ForecastDay data={dailyForecast} />
                </div>
              );
            }
          })}
        </div>
      </div>
    );
  } else {
    let apiKey = "86d11b15bf79a84309ce4be6o80tad43";
    let url = `https://api.shecodes.io/weather/v1/forecast?query=${props.info.city}&key=${apiKey}&units=imperial`;
    axios.get(url).then(getResponse);

    return null;
  }
}
